import React from 'react'
import { RouteObject } from 'react-router-dom'

import { MainLayout } from '@components/systems'
import { AccessGuard } from '@guards'

import AdminHomePage from '@pages/admin/AdminHome.page'
import AccessControlPage from '@pages/admin/AccessControl.page'
import MenuManagementPage from '@pages/admin/MenuManagement.page'
import CreateMenuPage from '@pages/admin/CreateMenu.page'
import AdminUsersPage from '@pages/admin/AdminUsers.page'

import ResetPasswordPage from '@pages/admin/ResetPassword.page'
import UserProfileImageUpdatePage from '@pages/admin/UserProfileImageUpdate.page'
import LogDashboardPage from '@pages/admin/LogDashboard.page'
import LogListPage from '@pages/admin/LogList.page'
import LogSettingsPage from '@pages/admin/LogSettings.page'
import AdminMyPage from '@pages/admin/AdminMyPage.page'
// @PLOP-IMPORTS

/* eslint-disable */
const AdminRoute: RouteObject[] = [
	{
		path: '/admin',
		element: (
			<AccessGuard>
				<MainLayout />
			</AccessGuard>
		),
		children: [
			{
				path: '/admin/empty',
				element: <></>,
			},
			{
				path: '/admin/home',
				element: <AdminHomePage />,
			},
			{
				path: '/admin/access-control',
				element: <AccessControlPage />,
			},
			{
				path: '/admin/menu',
				element: <MenuManagementPage />,
			},
			{
				path: '/admin/users',
				element: <AdminUsersPage />,
			},
			{
				path: '/admin/logs',
				element: <LogDashboardPage />,
			},
			{
				path: '/admin/logs/list',
				element: <LogListPage />,
			},
			{
				path: '/admin/logs/settings',
				element: <LogSettingsPage />,
			},
			// @PLOP-CODE
		],
	},
	{
		// My Page — 전체 화면이라 MainLayout 밖 형제 라우트다. /main/mypage 와 같은 페이지이고,
		// 관리자 모드에서 열면 모드가 main 으로 튀지 않도록 /admin 쪽 경로를 따로 둔다.
		path: '/admin/mypage',
		element: (
			<AccessGuard>
				<AdminMyPage />
			</AccessGuard>
		),
	},
	{
		path: '/admin/reset-password',
		element: (
			<AccessGuard>
				<ResetPasswordPage />
			</AccessGuard>
		),
	},
	{
		path: '/admin/user-profile-image-update',
		element: (
			<AccessGuard>
				<UserProfileImageUpdatePage />
			</AccessGuard>
		),
	},
	{
		path: '/admin/create-menu',
		element: <CreateMenuPage />,
	},
]

export default AdminRoute
